export default __webpack_public_path__ + "locales/pt/DeleteProfileEverDialog.json?hash=56222b085f1ed4afa93cbf439db40a54";